import { fireTag } from '@vue-util/tagManager';
import { MY_ACCOUNT_FALL_BACK_ERROR, DASHBOARD } from 'config';

const fireErrorTag = (err, error_scope = ['global'], error_label = DASHBOARD.tag.defaultErrorLabel) => {
  let errors = err;
  if (err?.response?.data?.errors) {
    errors = err?.response?.data?.errors;
  }
  fireTag('link', {
    ...DASHBOARD.tag.error,
    error_scope,
    error_label,
    error_code: [errors?.error?.[0]?.errorCode || errors?.errorCode || errors?.code || DASHBOARD.tag.defaultErrorCode],
    error_message: [errors?.error?.[0]?.message || errors?.message || MY_ACCOUNT_FALL_BACK_ERROR],
  });
};

export { fireErrorTag };
